export default {"src":"/assessments/student/_next/static/media/logo-geo.0e91536b.svg","height":28,"width":71,"blurWidth":0,"blurHeight":0};